import { TableRow, TableCell } from '@mui/material';
import { ReactNode } from 'react';

import { StatusChip } from '@occc/ui-design-system';
import { TriggeredMessageListItemFragment } from '@occc/graphql';

import { chipVariantByStatus } from '../triggered-messages-list.constants';
import { getTriggeredMessageType } from '../../triggered-messages.utils';
import { titleByStatus } from '../../triggered-messages.constants';

type TriggeredMessagesListItemProps = {
  message: TriggeredMessageListItemFragment;
  onClick?: () => void;
  contextMenu: ReactNode;
};

export const TriggeredMessagesListItem = (props: TriggeredMessagesListItemProps) => {
  const { message, onClick, contextMenu } = props;

  return (
    <TableRow onClick={onClick}>
      <TableCell>{message.description}</TableCell>
      <TableCell>{getTriggeredMessageType({ channels: message.channelsConfig })}</TableCell>
      <TableCell>
        <StatusChip
          label={titleByStatus[message.status]}
          variant={chipVariantByStatus[message.status]}
        />
      </TableCell>
      <TableCell align='right'>{contextMenu}</TableCell>
    </TableRow>
  );
};
